import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {setThousandSeparator, GetCardTypeForBody} from '../../../../../util/utils';
import PrintViewKnowledgeDescription from './PrintViewKnowledgeDescription';
import NumberFormat from 'react-number-format';
import {useUserPreferences} from '../../../../../util/customHooks';

export function PrintViewDecimalBody(props) {
	const {body} = props;

	const userPreferences = useUserPreferences();

	const formBodyBorder = GetCardTypeForBody(body);

	const getValue = () => {
		return body.bodyFreeText || '';
	};

	let valFormatter = setThousandSeparator(userPreferences.numberFormat);

	const mainBodyKey = `form-body-${body.id}-decimal`;

	return (
		<StyledPrintViewDecimalBody key={mainBodyKey} className={`StyledPrintViewDecimalBody ${formBodyBorder}`}>
			{body && body.id > 0 && <PrintViewKnowledgeDescription body={body} bodyDescription={body.name} />}
			<section className="SectionBodyData PrintViewDecimalBodyData">
				<section key={`${mainBodyKey}-value`} className="decimal-body-value">
					<NumberFormat
						value={getValue()}
						isNumericString
						displayType="text"
						thousandSeparator={valFormatter.thousandSeparator}
						thousandsGroupStyle={valFormatter.thousandsGroupStyle}
						decimalSeparator={valFormatter.decimalSeparator}
					/>
				</section>
			</section>
		</StyledPrintViewDecimalBody>
	);
}

const StyledPrintViewDecimalBody = styled.section`
	.SectionBodyData {
		margin-top: var(--px-10);
		display: block !important;
	}
	.decimal-body-value {
		padding: var(--px-1) var(--px-6);
		margin-top: var(--px-5);
		max-width: var(--px-200);
		min-height: var(--px-25);
		border: var(--px-1) solid var(--neutrals-300) !important;
	}
`;

export default PrintViewDecimalBody;
